<div [class]="cssClass">
  <div
		[ngClass]="{
			'unverified-user':
				userStatus !== userVerificationStatus.DOCUMENTED && userStatus !== userVerificationStatus.VERIFIED,
			'gold-membership': membership === userMembership.Gold,
			'silver-membership': membership === userMembership.Silver
		}">
    <img
      [src]="logo"
      [alt]="'avatar_alt_text' | translate"
      class="user-type"
			[ngClass]="{
				'gold-custom-padding': membership === userMembership.Gold,
				'silver-custom-padding': membership === userMembership.Silver
			}" />
  </div>
  @if (userStatus === userVerificationStatus.DOCUMENTED || userStatus === userVerificationStatus.VERIFIED) {
    <img
      [src]="validationLogo"
      [alt]="'verification-status-image-alt-text' | translate"
      class="user-validation-logo"
		[ngClass]="{
			'gold-custom-location': membership === userMembership.Gold,
			'silver-custom-location': membership === userMembership.Silver
		}" />
  }
</div>
